// Linear-time email shape check — behavior-equivalent to the historical
// /^[^\s@]+@[^\s@]+\.[^\s@]+$/ regex (sonarjs super-linear-regex class,
// 2026-07-06): exactly one "@", no whitespace anywhere, non-empty local part,
// and the domain contains a "." with at least one character on each side of
// its LAST dot. Parity corpus: email-shape.test.ts.
export function isEmailShaped(value: string): boolean {
  if (/\s/.test(value)) return false;
  const at = value.indexOf("@");
  if (at <= 0) return false;
  if (value.indexOf("@", at + 1) !== -1) return false;
  const domain = value.slice(at + 1);
  const lastDot = domain.lastIndexOf(".");
  return lastDot > 0 && lastDot < domain.length - 1;
}
